import React from 'react';
import { useJobSummary } from '../../../Data/Jobs';
import Loading from '../../../Components/Loading';
import Tile from '../../../Components/Containers/Tile';
import Statuses from '../../../Components/Widgets/Jobs/Statuses';

const JobsSummary = ({title = 'Jobs'}) => {
    const {summary}  = useJobSummary(true);

    return <Tile title={title} icon="ListCheck" className="py-4" zeroPadding>
        {summary ? <Statuses className="justify-around" jobs={summary.statuses} limit={null} /> : <Loading size="4x" center />}
    </Tile>
}

export default JobsSummary;
